module.exports = __webpack_public_path__ + "img/stickers_0003_crown.f81c9435.png";